import { render } from "./form.vue?vue&type=template&id=4ad1abf8&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=4ad1abf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4ad1abf8"

export default script